import VerifyAccessLevel from './VerifyAccessLevel';

export default VerifyAccessLevel;
